<template>
    <div class="partners_menu">
        <div class="row">
            <div class="col-sm-12 p-lr-0-sm">
                <div class="row">
                    <div class="col-lg-4 col-md-6 col-xl-4 col-xxl-3 col-sm-12 col-12 mb-4 p-lr-0-sm">
                        <div class="card">
                            <div class="card-body p-3">
                                <div class="col-sm-12 dis-flex flex-sb p-0">
                                    <div class="dis-flex flex-m flex-col m-auto">
                                        <label class="label_name mb-3">Smiltene</label>
                                        <div class="sidebar-cat-icon dis-flex flex-m flex-c">
                                            <div class="brand_logo">
                                                <img src="https://smiltenespiens.lv/wp-content/themes/SmiltenesPiensWP/assets/images/header/smiltene-logo-dark.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-xl-4 col-xxl-3 col-sm-12 col-12 mb-4 p-lr-0-sm">
                        <div class="card">
                            <div class="card-body p-3">
                                <div class="col-sm-12 dis-flex flex-sb p-0">
                                    <div class="dis-flex flex-m flex-col m-auto">
                                        <label class="label_name mb-3">Jaunpils Piens</label>
                                        <div class="sidebar-cat-icon dis-flex flex-m flex-c">
                                            <div class="brand_logo">
                                                <img src="https://jaunpilspienotava.lv/svg/logo.svg" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-xl-4 col-xxl-3 col-sm-12 col-12 mb-4 p-lr-0-sm">
                        <div class="card">
                            <div class="card-body p-3">
                                <div class="col-sm-12 dis-flex flex-sb p-0">
                                    <div class="dis-flex flex-m flex-col m-auto">
                                        <label class="label_name mb-3">mlekpol</label>
                                        <div class="sidebar-cat-icon dis-flex flex-m flex-c">
                                            <div class="brand_logo">
                                                <img src="https://mlekpol.com.pl/wp-content/uploads/2022/07/Logo_Mlekpol_2022-1.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>
.partners_menu {
    padding-top: 2rem;

    .sidebar-cat-icon {
        width: 128px;
        height: 128px;
        margin-right: 0;
        border-radius: 0;
        box-shadow: unset;
        padding: 0;

        .brand_logo {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;

            img {
                height: 100%;
            }
        }
    }

    .label_name {
        text-transform: uppercase;
        font-weight: 700;
    }

    .small-form-btn {
        display: flex!important;
        align-items: center!important;
        justify-content: center!important;
        max-height: 20px;
        padding: .2rem .65rem;
    }

    .form-control {
        color: var(--cl-text-extend);
    }
}
</style>